<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-input
          placeholder="统一社会信用代码"
          v-model.trim="code"
          class="handle-input mr10"
        ></el-input>
        <el-input
          placeholder="用户名称"
          v-model.trim="name"
          class="handle-input mr10"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getData(1)"
          >搜索</el-button
        >
      </div>
      <el-table
        :data="data.records"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column width="80px" align="center" label="序号" type="index">
          <template #default="scope">
            <span>{{
              data.total-((data.current - 1) * 20 + scope.$index )
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="invitationCode"
          align="center"
          label="保荐码"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="用户名称"
        ></el-table-column>
        <el-table-column
          prop="legalPerson"
          label="法定代表人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="unifiedSocialCreditCode"
          align="center"
          label="统一社会信用代码"
        ></el-table-column>
        <el-table-column
          prop="username"
          align="center"
          label="创建账号"
        ></el-table-column>
        <el-table-column align="center" label="保荐人">
          <template #default="scope">{{ scope.row.inviter || "-" }} </template>
        </el-table-column>
        <el-table-column label="认证时间" align="center">
          <template #default="scope"
            >{{ $utils.formatDate(scope.row.auditTime, "yyyy-MM-dd") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template #default="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="data.current"
          :page-size="20"
          :total="data.total"
          @current-change="getData"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      itemData: {},
      editVisible: false,
      loading: false,
      reject_dialog: false,
      auditRemark: "",
      code: "",
      name: "",
    };
  },
  methods: {
    async getData(page) {
      const params = {
        code: this.code,
        name: this.name,
        currentPage: page,
        pageSize: 20,
      };
      this.$loading.start();
      const res = await this.$api.account.getCompanyList(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEdit(data) {
      this.$router.push(`/account/company/${data.id}`);
    },
    idType(type) {
      switch (type) {
        case 1:
          return "身份证";
        case 2:
          return "护照";
        case 3:
          return "其他";
      }
    },
  },
  mounted() {
    this.getData();
  },
  
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;
}

.editVisible-dialog {
  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      padding: 0;
      &:first-child {
        td {
          border-top: 1px solid #ebeef5;
        }
      }
      td {
        padding: 10px;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        &:first-child {
          width: 130px;
          border-left: 1px solid #ebeef5;
        }
      }
    }
  }
  .upload-file {
    height: 40px;
    line-height: 40px;
  }
  .file-img {
    img {
      width: 200px;
      vertical-align: top;
      &:first-child {
        margin-right: 10px;
      }
    }
  }
}
</style>